import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/auth.js';
import Layout from './components/Layout.jsx';
import LandingPage from './pages/LandingPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import RegisterPage from './pages/RegisterPage.jsx';
import TemplatesPage from './pages/TemplatesPage.jsx';
import TemplateEditor from './pages/TemplateEditor.jsx';
import AssetsPage from './pages/AssetsPage.jsx';
import ScriptsPage from './pages/ScriptsPage.jsx';
import JobsPage from './pages/JobsPage.jsx';
import ReportsPage from './pages/ReportsPage.jsx';
import SettingsPage from './pages/SettingsPage.jsx';
import UsersPage from './pages/UsersPage.jsx';
import AdminSettingsPage from './pages/AdminSettingsPage.jsx';
import PlansPage from './pages/PlansPage.jsx';
import BillingSettingsPage from './pages/BillingSettingsPage.jsx';
import TermsOfServicePage from './pages/TermsOfServicePage.jsx';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.jsx';
import LegalNoticePage from './pages/LegalNoticePage.jsx';
import ApiReferencePage from './pages/ApiReferencePage.jsx';
import DocumentationPage from './pages/DocumentationPage.jsx';
import CategoryPage from './pages/CategoryPage.jsx';
import SystemStatusPage from './pages/SystemStatusPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import ProfilePage from './pages/ProfilePage.jsx';

function ProtectedRoute({ children }) {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/terminos-de-servicio" element={<TermsOfServicePage />} />
      <Route path="/politica-de-privacidad" element={<PrivacyPolicyPage />} />
      <Route path="/aviso-legal" element={<LegalNoticePage />} />
      <Route path="/referencia-api" element={<ApiReferencePage />} />
      <Route path="/documentacion" element={<DocumentationPage />} />
      <Route path="/estado-del-sistema" element={<SystemStatusPage />} />
      <Route path="/c/:categoryId" element={<CategoryPage />} />
      <Route path="/c/:categoryId/:articleId" element={<CategoryPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/templates" element={<TemplatesPage />} />
                <Route path="/templates/:id" element={<TemplateEditor />} />
                <Route path="/assets" element={<AssetsPage />} />
                <Route path="/scripts" element={<ScriptsPage />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/admin-settings" element={<AdminSettingsPage />} />
                <Route path="/plans" element={<PlansPage />} />
                <Route path="/billing-settings" element={<BillingSettingsPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
